export default __webpack_public_path__ + "393cdc1b922f70b011f3254c67ca962a.png";